<img [src]="darkMode ? darkLogo : logo" [style.max-height]="maxHeight + 'px'" [style.max-width]="maxWidth + 'px'"/>

